import React from 'react';
import { Carousel as AntCarousel, CarouselProps as AntCarouselProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface CarouselProps extends AntCarouselProps {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  carousel: {
    '& .slick-slider': {
      backgroundColor: theme.color.semantic.background.neutral.subtle,
    },
    '& .slick-dots': {
      '& li': {
        width: '24px',
        height: '8px',
        margin: `${theme.spacing[0]} ${theme.spacing[1]}`,
      },
      '& li button': {
        backgroundColor: theme.color.semantic.background.neutral.strongL1,
        borderRadius: theme.radius.xs,
        width: '24px',
        height: '8px',
        opacity: theme.opacity[100],
      },
      '& li:hover button': {
        backgroundColor: theme.color.semantic.background.neutral.strong,
      },
      '& li.slick-active': {
        width: '24px',
      },
      '& li.slick-active button': {
        backgroundColor: theme.color.semantic.background.neutral.inverse,
        width: '24px',
      },
    },
    '& .slick-prev, & .slick-next': {
      zIndex: 1,
      width: '32px',
      height: '32px',
      backgroundColor: theme.color.semantic.background.neutral.subtle,
      borderRadius: theme.radius.md,
      padding: theme.spacing[1],
      display: 'flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      '&::before': {
        color: theme.color.semantic.background.neutral.strongL1,
        fontSize: theme.typography.fontSize.lg,
        opacity: theme.opacity[100],
      },
      '&:hover': {
        backgroundColor: theme.color.semantic.background.neutral.subtle,
        '&::before': {
          color: theme.color.semantic.background.neutral.strong,
        },
      },
      '&:focus, &:active': {
        backgroundColor: theme.color.semantic.background.neutral.subtle,
        '&::before': {
          color: theme.color.semantic.background.neutral.inverse,
        },
      },
    },
    '& .slick-prev': {
      left: '10px',
    },
    '& .slick-next': {
      right: '10px',
    },
  },
}));

const Carousel = React.forwardRef<any, CarouselProps>(
  ({ className = '', arrows = true, ...rest }, ref) => {
    const classes = useStyles();
    return (
      <AntCarousel
        {...rest}
        ref={ref}
        arrows={arrows}
        className={`${classes.carousel} ${className}`.trim()}
      />
    );
  }
);

Carousel.displayName = 'Carousel';

export default Carousel;
